import chatbotIcon from "../../assest/chatbot.png";

/**
 * RAG Widget
 * A standalone vanilla JS widget for Grievance Redressal Chatbot.
 */
(function (window) {
  'use strict';

  // --- Configuration & State ---
  const CONFIG = {
    backendBaseUrl: 'https://demo-grv-backend.vercel.app/api/v1',
    feedbackUrl: "https://dashboard.dhenkanalservice.in/api",
    containerId: null,
    primaryColor: '#2563eb', // blue-600
    secondaryColor: '#1d4ed8', // blue-700
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  };

  const getStoredLanguage = () => {
    try {
      const storedLang = localStorage.getItem('i18nextLng');
      return ['en', 'hi', 'od'].includes(storedLang) ? storedLang : 'en';
    } catch (error) {
      console.error('Error reading language from localStorage:', error);
      return 'en';
    }
  };

  const STATE = {
    isOpen: false,
    messages: [],
    currentStep: 'select_language', // Initial step
    lang: getStoredLanguage(),
    userDetails: {
      category: '',
      userName: '',
      userPhone: '',
      grievantName: '',
      grievantPhone: '',
      grievance: '',
    },
    feedbackDetails: {
      name: '',
      mobileNumber: '',
      feedback: ''
    },
    selectedService: '',
    token: null,
    isProcessing: false,
    isListening: false,
    infoMemory: [], // For RAG context
    mediaRecorder: null,
    audioChunks: [],
  };

  // --- Localization Data (Embedded) ---
  const LOCALES = {
    en: {
      samadhan: "Samadhan",
      greeting: "Hello! Welcome to the Grievance Registration System.",
      who_are_you: "Who are you?",
      // 'Self', 'Asha Karmi', 'Anganbadi Karmi', 'CSC', 'Ration_Card_Dealer', 'Other'
      categories: { self: "Self", ashakarmi: "Asha Karmi", anganbadikarmi: "Anganbadi Karmi", csc: "Jana Seva Kendra", ration_card_dealer: "Ration Card Dealer", other: "Other" },
      enter_name: "Please enter your name:",
      enter_concerned_name: "Please enter the concerned individual's name:",
      enter_phone: "Please enter your phone number (10 digits):",
      enter_grievant_name: "Please enter the name of the {category}:",
      enter_grievant_phone: "Please enter their phone number (10 digits) or press the skip button if unavailable:",
      enter_otp: "Please enter the OTP sent to your phone:",
      otp_sent: "An OTP has been sent to your phone number.",
      otp_verified: "OTP verified successfully.",
      error_otp: "Invalid OTP. Please try again.",
      skip: "Skip",
      skipped: "Skipped",
      grievance_details: "Grievance Details",
      describe_grievance: "Describe your grievance *",
      placeholder_grievance: "Please provide details about your grievance...",
      upload_documents: "Upload documents",
      submit: "Submit",
      submitting: "Submitting...",
      cancel: "Cancel",
      greeting_start: "Hi! Type \"Hi\" or \"Hello\" to start registering a grievance.",
      greeting_response: "Hello! Please type \"Hi\" or \"Hello\" to start registration.",
      grievance_registered: "Thank you. Your grievance has been registered successfully. Your Grievance ID is {id}.",
      form_cancelled: "Reload the page to start over.",
      location_error: "Note: Could not get your location. {error}",
      error_submitting: "Sorry, there was an error submitting your grievance. Please try again.",
      error_phone: "Please enter a valid 10-digit phone number",
      error_description: "Please describe your grievance",
      getting_location: "Getting your location...",
      chat_title: "Grievance Registration",
      placeholder_message: "Type your message...",
      select_language: "Select language",
      select_service: "Please select a service:",
      service_know_citizen: "Know your citizen Services",
      service_grievance_registration: "Grievance Registration",
      service_check_status: "Check Grievance Status",
      service_feedback: "Feedback",
      coming_soon: "Coming soon.",
      service_info_prompt: "Ask me about citizen services or schemes.",
      service_info_error: "Sorry, I could not fetch service details. Please try again.",
      feedback_prompt: "Please share your feedback (include name/phone if you want a follow-up).",
      feedback_thanks: "Thanks for your feedback!",
      feedback_error: "Sorry, we could not save your feedback. Please try again.",
      enter_aadhar: "Please enter your AADHAR card number (12 digits):",
      error_aadhar: "Please enter a valid 12-digit AADHAR number",
      feedback_details_title: "Feedback Details",
      feedback_describe_label: "Describe your feedback *",
      feedback_placeholder: "Please provide details about your feedback...",
      identity_response: "I am a helpful assistant for citizens of Dhenkanal, Odisha. I am an expert on government schemes and citizen services in Odisha, India.",
      check_grievance_status: "Check Grievance Status",
      placeholder_grievance_id: "Enter Grievance ID (e.g., GR-2025-001)",
      search: "Search",
      searching: "Searching...",
      grievance_id: "Grievance ID",
      category: "Category",
      department: "Department",
      submitted_on: "Submitted On",
      description: "Description",
      status_timeline: "Status Timeline",
      estimated_resolution: "Estimated Resolution Date",
      error_grievance_id_required: "Please enter a grievance ID",
      error_grievance_not_found: "Grievance not found",
      error_fetching_status: "Error fetching status",
      error_auth: "Please login to use voice features",
      error_location_unavailable: "Unable to get your location. Please try again."
    },
    hi: {
      samadhan: "समाधान",
      greeting: "नमस्कार! शिकायत पंजीकरण प्रणाली में आपका स्वागत है।",
      who_are_you: "आप कौन हैं?",
      categories: { self: "खुद", ashakarmi: "आशा कर्मी", anganbadikarmi: "अंगनवाड़ी कर्मी", csc: "जन सेवा केंद्र", ration_card_dealer: "राशन कार्ड डीलर", other: "अन्य" },
      enter_name: "कृपया अपना नाम दर्ज करें:",
      enter_concerned_name: "कृपया संबंधित व्यक्ति का नाम दर्ज करें:",
      enter_phone: "कृपया अपना फोन नंबर दर्ज करें (10 अंक):",
      enter_grievant_name: "कृपया {category} का नाम दर्ज करें:",
      enter_grievant_phone: "कृपया उनका फ़ोन नंबर (10 अंक) दर्ज करें या उपलब्ध न होने पर छोड़ें बटन दबाएँ:",
      enter_otp: "कृपया अपने फ़ोन पर भेजा गया ओटीपी दर्ज करें:",
      otp_sent: "आपके फ़ोन नंबर पर एक ओटीपी भेजा गया है।",
      otp_verified: "ओटीपी सफलतापूर्वक सत्यापित हो गया है।",
      error_otp: "अमान्य ओटीपी। कृपया पुनः प्रयास करें।",
      skip: "छोडना",
      skipped: "छोड़ा गया",
      grievance_details: "शिकायत विवरण",
      describe_grievance: "अपनी शिकायत बताएं *",
      placeholder_grievance: "कृपया अपनी शिकायत के बारे में विवरण दें...",
      upload_documents: "दस्तावेज़ अपलोड करें",
      submit: "जमा करें",
      submitting: "जमा किया जा रहा है...",
      cancel: "रद्द करें",
      greeting_start: "नमस्कार! शिकायत पंजीकरण शुरू करने के लिए \"नमस्कार\" या \"हैलो\" टाइप करें।",
      greeting_response: "नमस्कार! पंजीकरण शुरू करने के लिए कृपया \"नमस्कार\" या \"हैलो\" टाइप करें।",
      grievance_registered: "धन्यवाद। आपकी शिकायत सफलतापूर्वक पंजीकृत कर ली गई है। आपकी शिकायत आईडी है {id}।",
      form_cancelled: "पुनः शुरू करने के लिए पृष्ठ को पुनः लोड करें।",
      location_error: "नोट: आपका स्थान प्राप्त नहीं किया जा सका। {error}",
      error_submitting: "क्षमा करें, आपकी शिकायत जमा करने में त्रुटि हुई। कृपया फिर से प्रयास करें।",
      error_phone: "कृपया एक मान्य 10 अंकों का फोन नंबर दर्ज करें",
      error_description: "कृपया अपनी शिकायत बताएं",
      getting_location: "आपका स्थान प्राप्त किया जा रहा है...",
      chat_title: "शिकायत पंजीकरण",
      placeholder_message: "अपना संदेश टाइप करें...",
      select_language: "भाषा चुनें",
      select_service: "कृपया सेवा चुनें:",
      service_know_citizen: "नागरिक सेवाएं जानें",
      service_grievance_registration: "शिकायत पंजीकरण",
      service_check_status: "शिकायत की स्थिति जांचें",
      service_feedback: "प्रतिपुष्टि",
      coming_soon: "जल्द आ रहा है।",
      service_info_prompt: "नागरिक सेवाओं या योजनाओं के बारे में पूछें। मैं उपलब्ध डेटा का उपयोग करूंगा और किसी भी कमी को पूछूंगा।",
      service_info_error: "क्षमा करें, सेवा विवरण नहीं मिल पाए। कृपया फिर से प्रयास करें।",
      feedback_prompt: "कृपया अपनी प्रतिपुष्टि साझा करें (अनुवर्तन के लिए चाहें तो नाम/फोन शामिल करें)।",
      feedback_thanks: "आपकी प्रतिपुष्टि के लिए धन्यवाद!",
      feedback_error: "क्षमा करें, हम आपकी प्रतिपुष्टि सहेज नहीं पाए। कृपया फिर से प्रयास करें।",
      enter_aadhar: "कृपया अपना आधार कार्ड नंबर दर्ज करें (12 अंक):",
      error_aadhar: "कृपया एक मान्य 12 अंकों का आधार नंबर दर्ज करें",
      feedback_details_title: "प्रतिक्रिया विवरण",
      feedback_describe_label: "अपनी प्रतिक्रिया लिखें *",
      feedback_placeholder: "कृपया अपनी प्रतिक्रिया का विवरण दें...",
      identity_response: "मैं धेनकानाल, ओडिशा के नागरिकों के लिए एक सहायक सहायक हूँ। मैं ओडिशा, भारत की सरकारी योजनाओं और नागरिक सेवाओं में विशेषज्ञ हूँ।",
      check_grievance_status: "शिकायत की स्थिति जांचें",
      placeholder_grievance_id: "शिकायत आईडी दर्ज करें (उदा. GR-2025-001)",
      search: "खोजें",
      searching: "खोज रहा है...",
      grievance_id: "शिकायत आईडी",
      category: "श्रेणी",
      department: "विभाग",
      submitted_on: "जमा किया गया",
      description: "विवरण",
      status_timeline: "स्थिति समयरेखा",
      estimated_resolution: "अनुमानित समाधान तिथि",
      error_grievance_id_required: "कृपया शिकायत आईडी दर्ज करें",
      error_grievance_not_found: "शिकायत नहीं मिली",
      error_fetching_status: "स्थिति प्राप्त करने में त्रुटि",
      error_auth: "वॉयस सुविधाओं का उपयोग करने के लिए कृपया लॉगिन करें",
      error_location_unavailable: "आपका स्थान प्राप्त करने में असमर्थ। कृपया पुनः प्रयास करें।"
    },
    od: {
      samadhan: "ସମାଧାନ",
      greeting: "ନମସ୍କାର! ଅଭିଯୋଗ ପଞ୍ଜୀକରଣ ପ୍ରଣାଳୀରେ ଆପଣଙ୍କ ସ୍ୱାଗତ ।",
      who_are_you: "ଆପଣ କିଏ?",
      categories: { self: "ନିଜେ", ashakarmi: "ଆଶା କର୍ମୀ", anganbadikarmi: "ଅଙ୍ଗନବାଡ଼ୀ କର୍ମୀ", csc: "ଜନ ସେବା କେନ୍ଦ୍ର", ration_card_dealer: "ରାଶନ କାର୍ଡ ଡିଲର", other: "ଅନ୍ୟ" },
      enter_name: "ଦୟାକରି ଆପଣଙ୍କ ନାମ ଲେଖନ୍ତୁ:",
      enter_concerned_name: "ଦୟାକରି ସମ୍ପୃକ୍ତ ବ୍ୟକ୍ତିଙ୍କ ନାମ ଲେଖନ୍ତୁ:",
      enter_phone: "ଦୟାକରି ଆପଣଙ୍କ ଫୋନ ନମ୍ବର ଲେଖନ୍ତୁ (10 ଅଙ୍କ):",
      enter_grievant_name: "ଦୟାକରି {category}ଙ୍କ ନାମ ଲେଖନ୍ତୁ:",
      enter_grievant_phone: "ଦୟାକରି ତାଙ୍କର ଫୋନ୍ ନମ୍ବର (୧୦ ଅଙ୍କ) ଲେଖନ୍ତୁ କିମ୍ବା ଉପଲବ୍ଧ ନ ଥିଲେ ବାଦ ଦିଅନ୍ତୁ ବଟନ୍ ଦବାନ୍ତୁ:",
      enter_otp: "ଦୟାକରି ଆପଣଙ୍କ ଫୋନକୁ ପଠାଯାଇଥିବା OTP ପ୍ରବେଶ କରନ୍ତୁ:",
      otp_sent: "ଆପଣଙ୍କ ଫୋନ ନମ୍ବରକୁ ଗୋଟିଏ OTP ପଠାଯାଇଛି।",
      otp_verified: "OTP ସଫଳତାର ସହ ଯାଞ୍ଚ ହୋଇଛି।",
      error_otp: "ଅବୈଧ OTP। ଦୟାକରି ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
      skip: "ବାଦ୍ ଦିଅନ୍ତୁ",
      skipped: "ବାଦ୍ ଦିଆଯାଇଛି",
      grievance_details: "ଅଭିଯୋଗ ବିବରଣୀ",
      describe_grievance: "ଆପଣଙ୍କ ଅଭିଯୋଗ ବର୍ଣ୍ଣନା କରନ୍ତୁ *",
      placeholder_grievance: "ଦୟାକରି ଆପଣଙ୍କ ଅଭିଯୋଗ ବିଷୟରେ ବିବରଣୀ ଦିଅନ୍ତୁ...",
      upload_documents: "ଡକ୍ୟୁମେଣ୍ଟ ଅପଲୋଡ୍ କରନ୍ତୁ",
      submit: "ଜମା କରନ୍ତୁ",
      submitting: "ଜମା ହେଉଛି...",
      cancel: "ବାତିଲ କରନ୍ତୁ",
      greeting_start: "ନମସ୍କାର! ଅଭିଯୋଗ ପଞ୍ଜୀକରଣ ଆରମ୍ଭ କରିବାକୁ \"ନମସ୍କାର\" କିମ୍ବା \"ହେଲ୍ଲୋ\" ଲେଖନ୍ତୁ।",
      greeting_response: "ନମସ୍କାର! ପଞ୍ଜୀକରଣ ଆରମ୍ଭ କରିବାକୁ ଦୟାକରି \"ନମସ୍କାର\" କିମ୍ବା \"ହେଲ୍ଲୋ\" ଲେଖନ୍ତୁ।",
      grievance_registered: "ଧନ୍ୟବାଦ। ଆପଣଙ୍କ ଅଭିଯୋଗ ସଫଳତାର ସହ ନିବନ୍ଧିତ ହୋଇଛି। ଆପଣଙ୍କ ଅଭିଯୋଗ ଆଇଡି ହେଉଛି {id}।",
      form_cancelled: "ପୁଣି ଆରମ୍ଭ କରିବାକୁ ପୃଷ୍ଠାକୁ ରିଲୋଡ୍ କରନ୍ତୁ।",
      location_error: "ଦ୍ରଷ୍ଟବ୍ୟ: ଆପଣଙ୍କ ଅବସ୍ଥିତି ପ୍ରାପ୍ତ କରିପାରିଲା ନାହିଁ। {error}",
      error_submitting: "କ୍ଷମା କରନ୍ତୁ, ଆପଣଙ୍କ ଅଭିଯୋଗ ଜମା କରିବାରେ ତ୍ରୁଟି ହୋଇଛି। ଦୟାକରି ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ।",
      error_phone: "ଦୟାକରି ଏକ ବୈଧ 10 ଅଙ୍କର ଫୋନ ନମ୍ବର ଲେଖନ୍ତୁ",
      error_description: "ଦୟାକରି ଆପଣଙ୍କ ଅଭିଯୋଗ ବର୍ଣ୍ଣନା କରନ୍ତୁ",
      getting_location: "ଆପଣଙ୍କ ଅବସ୍ଥିତି ପ୍ରାପ୍ତ ହେଉଛି...",
      chat_title: "ଅଭିଯୋଗ ପଞ୍ଜୀକରଣ",
      placeholder_message: "ଆପଣଙ୍କ ସନ୍ଦେଶ ଲେଖନ୍ତୁ...",
      select_language: "ଭାଷା ଚୟନ କରନ୍ତୁ",
      select_service: "ଦୟାକରି ସେବା ବାଛନ୍ତୁ:",
      service_know_citizen: "ନାଗରିକ ସେବା ଜାଣନ୍ତୁ",
      service_grievance_registration: "ଅଭିଯୋଗ ପଞ୍ଜୀକରଣ",
      service_check_status: "ଅଭିଯୋଗ ସ୍ଥିତି ଯାଞ୍ଚ କରନ୍ତୁ",
      service_feedback: "ମତାମତ",
      coming_soon: "ଶୀଘ୍ର ଆସୁଛି।",
      service_info_prompt: "ନାଗରିକ ସେବା କିମ୍ବା ଯୋଜନା ସମ୍ବନ୍ଧରେ ପଚାରନ୍ତୁ।",
      service_info_error: "କ୍ଷମା କରନ୍ତୁ, ସେବା ବିବରଣୀ ମିଳିଲା ନାହିଁ। ପୁନି ଚେଷ୍ଟା କରନ୍ତୁ।",
      feedback_prompt: "ଦୟାକରି ଆପଣଙ୍କ ମତାମତ ସେୟାର କରନ୍ତୁ (ପୁନଃ ସମ୍ପର୍କ ପାଇଁ ଚାହିଲେ ନାମ/ଫୋନ ଦିଅନ୍ତୁ)।",
      feedback_thanks: "ଆପଣଙ୍କ ମତାମତ ପାଇଁ ଧନ୍ୟବାଦ!",
      feedback_error: "କ୍ଷମା କରନ୍ତୁ, ମତାମତ ସେଭ୍ କରିପାରିଲୁ ନାହିଁ। ଦୟାକରି ପୁନି ଚେଷ୍ଟା କରନ୍ତୁ।",
      enter_aadhar: "ଦୟାକରି ଆପଣଙ୍କ ଆଧାର କାର୍ଡ ସଂଖ୍ୟା (୧୨ ଅଙ୍କ) ଲେଖନ୍ତୁ:",
      error_aadhar: "ଦୟାକରି ୧୨ ଅଙ୍କର ବୈଧ ଆଧାର ନମ୍ବର ଲେଖନ୍ତୁ",
      feedback_details_title: "ମତାମତ ବିବରଣୀ",
      feedback_describe_label: "ଆପଣଙ୍କ ମତାମତ ଲେଖନ୍ତୁ *",
      feedback_placeholder: "ଦୟାକରି ଆପଣଙ୍କ ମତାମତ ବିଷୟରେ ବିବରଣୀ ଦିଅନ୍ତୁ...",
      identity_response: "ମୁଁ ଧେନକାନାଳ, ଓଡିଶାର ନାଗରିକଙ୍କ ପାଇଁ ସହାୟକ। ମୁଁ ଓଡିଶା, ଭାରତର ସରକାରୀ ଯୋଜନା ଏବଂ ନାଗରିକ ସେବାରେ ଦକ୍ଷ।",
      check_grievance_status: "ଅଭିଯୋଗ ସ୍ଥିତି ଯାଞ୍ଚ କରନ୍ତୁ",
      placeholder_grievance_id: "ଅଭିଯୋଗ ID ଲେଖନ୍ତୁ (ଉଦାହରଣ: GR-2025-001)",
      search: "ସନ୍ଧାନ",
      searching: "ସନ୍ଧାନ କରୁଛି...",
      grievance_id: "ଅଭିଯୋଗ ID",
      category: "ବର୍ଗ",
      department: "ବିଭାଗ",
      submitted_on: "ଦାଖଲ କରାଯାଇଛି",
      description: "ବିବରଣୀ",
      status_timeline: "ସ୍ଥିତି ସମୟରେଖା",
      estimated_resolution: "ଆନୁମାନିକ ସମାଧାନ ତାରିଖ",
      error_grievance_id_required: "ଦୟାକରି ଅଭିଯୋଗ ID ଲେଖନ୍ତୁ",
      error_grievance_not_found: "ଅଭିଯୋଗ ମିଳିଲା ନାହିଁ",
      error_fetching_status: "ସ୍ଥିତି ଆଣିବାରେ ତ୍ରୁଟି",
      error_auth: "ଭଏସ୍ ବୈଶିଷ୍ଟ୍ୟ ବ୍ୟବହାର କରିବାକୁ ଦୟାକରି ଲଗ୍ ଇନ୍ କରନ୍ତୁ",
      error_location_unavailable: "ଆପଣଙ୍କ ଅବସ୍ଥିତି ପାଇବାରେ ଅସମର୍ଥ | ଦୟାକରି ପୁନର୍ବାର ଚେଷ୍ଟା କରନ୍ତୁ |"
    }
  };

  // --- Assets (Icons as SVGs) ---
  const ICONS = {
    bot: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6V2H8"/><path d="m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z"/><path d="M2 12h2"/><path d="M9 11v2"/><path d="M15 11v2"/><path d="M20 12h2"/></svg>`,
    close: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 18 12"/></svg>`,
    send: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>`,
    mic: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><path d="M12 19v4"/><path d="M8 23h8"/></svg>`,
    micOff: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="1" y1="1" x2="23" y2="23"/><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"/><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>`,
    arrowLeft: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>`,
    robot: `<img src="${chatbotIcon}" alt="Chatbot" style="width: 100%; height: 100%; object-fit: contain;">` // Fallback if image fails, use SVG
  };

  // --- Helper Functions ---
  function t(key, replacements) {
    let value = LOCALES[STATE.lang][key] || key;
    if (replacements) {
      Object.entries(replacements).forEach(([k, v]) => {
        value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
      });
    }
    return value;
  }

  function injectStyles() {
    const styleId = 'rag-widget-styles';
    if (document.getElementById(styleId)) return;

    const css = `
            #rag-widget-root {
                font-family: ${CONFIG.fontFamily};
                position: fixed;
                bottom: 24px;
                right: 24px;
                z-index: 9999;
            }
            .irw-btn-float {
                width: 96px;
                height: 96px;
                border-radius: 50%;
                background: linear-gradient(135deg, #a855f7 0%, #ec4899 100%);
                box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
                border: none;
                cursor: pointer;
                transition: transform 0.2s;
                padding: 16px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative; /* For bubble positioning context if needed, though bubble is absolute relative to button */
            }
            .irw-btn-float:hover {
                transform: scale(1.05);
            }
            .irw-btn-float img {
                animation: icon-bounce 3s ease-in-out infinite;
                transform-origin: center;
            }
            .irw-float-bubble {
                position: absolute;
                top: -60px;
                left: 50%;
                transform: translateX(-50%);
                background: white;
                border-radius: 8px;
                padding: 4px 16px;
                box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                white-space: nowrap;
                pointer-events: none;
                animation: float 3s ease-in-out infinite;
            }
            .irw-float-bubble-text {
                font-size: 20px;
                font-weight: 700;
                color: #1f2937;
                margin: 0;
                font-family: sans-serif;
            }
            .irw-float-bubble-arrow {
                position: absolute;
                bottom: -6px;
                left: 50%;
                transform: translateX(-50%) rotate(45deg);
                width: 12px;
                height: 12px;
                background: white;
            }
            @keyframes float {
                0%, 100% { transform: translateX(-50%) translateY(0); }
                50% { transform: translateX(-50%) translateY(-5px); }
            }
            @keyframes icon-bounce {
                0%, 100% { transform: translateY(0); }
                50% { transform: translateY(-6px); }
            }
            .irw-chat-window {
                width: 380px;
                height: 600px;
                background: white;
                border-radius: 12px;
                box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
                display: flex;
                flex-direction: column;
                overflow: hidden;
                margin-bottom: 16px; 
                opacity: 0;
                transform: translateY(20px) scale(0.95);
                transition: opacity 0.3s, transform 0.3s;
                pointer-events: none;
                /* Removed absolute positioning as root is now fixed flex container */
                display: none; /* Hidden by default */
            }
            .irw-chat-window.open {
                display: flex; /* Show when open */
                opacity: 1;
                transform: translateY(0) scale(1);
                pointer-events: auto;
            }
            .irw-header {
                background: ${CONFIG.primaryColor};
                color: white;
                padding: 12px 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .irw-header-title {
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 8px;
            }
            .irw-btn-close {
                background: transparent;
                border: none;
                color: white;
                cursor: pointer;
                padding: 8px;
                border-radius: 6px;
                font-size: 20px;
                line-height: 1;
                width: 36px;
                height: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background 0.2s ease;
            }
            .irw-btn-close:hover {
                background: rgba(255,255,255,0.2);
            }
            .irw-messages {
                flex: 1;
                overflow-y: auto;
                padding: 16px;
                background: #f9fafb;
                display: flex;
                flex-direction: column;
                gap: 12px;
            }
            .irw-message {
                max-width: 80%;
                padding: 8px 12px;
                border-radius: 8px;
                font-size: 14px;
                line-height: 1.5;
                word-wrap: break-word;
            }
            .irw-message.bot {
                align-self: flex-start;
                background: #f3f4f6;
                color: #1f2937;
            }
            .irw-message.user {
                align-self: flex-end;
                background: ${CONFIG.primaryColor};
                color: white;
            }
            .irw-input-area {
                padding: 16px;
                border-top: 1px solid #e5e7eb;
                background: white;
                display: flex;
                gap: 8px;
                align-items: center;
            }
            .irw-input {
                flex: 1;
                padding: 8px 12px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                outline: none;
                font-size: 14px;
            }
            .irw-input:focus {
                border-color: ${CONFIG.primaryColor};
                box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
            }
            .irw-btn-icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background 0.2s;
            }
            .irw-btn-send {
                background: ${CONFIG.primaryColor};
                color: white;
            }
            .irw-btn-send:hover {
                background: ${CONFIG.secondaryColor};
            }
            .irw-btn-mic {
                background: ${CONFIG.primaryColor};
                color: white;
            }
            .irw-btn-mic.listening {
                background: black;
                /* animation: pulse 1.5s infinite; Removed pulse to match static black circle look if preferred, or keep it */
            }
            .irw-btn-mic:hover {
                background: ${CONFIG.secondaryColor};
            }
            .irw-mic-stop-icon {
                display: inline-block;
                width: 14px;
                height: 14px;
                background: white;
                border-radius: 2px;
            }
            .irw-options {
                display: flex;
                flex-wrap: wrap;
                gap: 8px;
                margin-bottom: 8px;
            }
            .irw-btn-option {
                padding: 8px 14px;
                margin: 4px 3px;
                border-radius: 8px;
                border: 2px solid #2563eb;
                background: white;
                color: #2563eb;
                font-weight: 600;
                font-size: 14px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
            }
            .irw-btn-option:hover {
                background: #2563eb;
                color: white;
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
            }
            .irw-back-btn {
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 10px 16px;
                margin-bottom: 16px;
                border-radius: 8px;
                border: none;
                background: transparent;
                color: #2563eb;
                font-weight: 600;
                font-size: 15px;
                cursor: pointer;
                transition: all 0.2s ease;
            }
            .irw-back-btn:hover {
                background: rgba(37, 99, 235, 0.1);
                color: #1d4ed8;
            }
            .irw-lang-btn {
                width: 100%;
                padding: 14px 20px;
                margin-bottom: 12px;
                border-radius: 12px;
                border: none;
                color: white;
                font-weight: 600;
                font-size: 16px;
                cursor: pointer;
                background: linear-gradient(135deg, #1e90ff 0%, #1ec8a5 100%);
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
            .irw-lang-btn:hover {
                background: linear-gradient(135deg, #1c7ed6 0%, #12b886 100%);
                transform: translateY(-2px);
                box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
            }
            .irw-service-btn {
                width: 100%;
                padding: 16px 20px;
                margin-bottom: 12px;
                border-radius: 12px;
                color: white;
                font-weight: 600;
                font-size: 16px;
                cursor: pointer;
                border: none;
                transition: all 0.3s ease;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
            .irw-service-btn:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
            }
            .irw-service-container {
                background: white;
                border-radius: 16px;
                padding: 24px;
                box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
            }
            .irw-service-title {
                font-size: 18px;
                font-weight: 600;
                color: #1f2937;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                gap: 12px;
            }
            .irw-loader {
                display: flex;
                gap: 4px;
                padding: 4px 0;
            }
            .irw-dot {
                width: 6px;
                height: 6px;
                background: ${CONFIG.primaryColor};
                border-radius: 50%;
                animation: bounce 1.4s infinite ease-in-out both;
            }
            .irw-dot:nth-child(1) { animation-delay: -0.32s; }
            .irw-dot:nth-child(2) { animation-delay: -0.16s; }
            
            @keyframes bounce { 0%, 80%, 100% { transform: scale(0); } 40% { transform: scale(1); } }
            @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.1); } 100% { transform: scale(1); } }

            .irw-form-container {
                background: white;
                border: 2px solid #e5e7eb;
                border-radius: 8px;
                padding: 16px;
                margin-bottom: 16px;
            }
            .irw-label {
                display: block;
                font-size: 14px;
                font-weight: 500;
                color: #374151;
                margin-bottom: 4px;
            }
            .irw-textarea {
                width: 100%;
                padding: 8px;
                padding-right: 48px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                min-height: 100px;
                margin-bottom: 12px;
                font-family: inherit;
                box-sizing: border-box;
            }
            .irw-textarea-container {
                position: relative;
                margin-bottom: 12px;
            }
            .irw-mic-textarea-btn {
                position: absolute;
                bottom: 20px;
                right: 12px;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: none;
                background: #2563eb;
                color: white;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: background 0.2s ease;
            }
            .irw-mic-textarea-btn:hover {
                background: #1d4ed8;
            }
            .irw-mic-textarea-btn.recording {
                background: #000;
            }
            .irw-file-input {
                width: 100%;
                margin-bottom: 12px;
                font-size: 14px;
            }
            .irw-btn-group {
                display: flex;
                gap: 8px;
            }
            .irw-btn-primary {
                flex: 1;
                background: ${CONFIG.primaryColor};
                color: white;
                padding: 8px;
                border-radius: 6px;
                border: none;
                cursor: pointer;
            }
            .irw-btn-secondary {
                flex: 1;
                background: #e5e7eb;
                color: #1f2937;
                padding: 8px;
                border-radius: 6px;
                border: none;
                cursor: pointer;
            }
            .irw-error {
                color: #ef4444;
                font-size: 12px;
                margin-top: 4px;
            }
            .irw-back-btn {
                background: #eff6ff;
                color: ${CONFIG.primaryColor};
                border: none;
                padding: 8px;
                border-radius: 4px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 4px;
                font-size: 14px;
                margin-bottom: 8px;
                width: fit-content;
            }




              @media (min-width: 1280px) and (max-width: 1535px) {
        /* Add your changes here */
        .irw-chat-window {
            width: 340px;
            height: 560px;
        }
    }

    /* LG Screen (1024px–1279px) */
    @media (min-width: 1024px) and (max-width: 1279px) {
        /* Add your changes here */
        .irw-chat-window {
            width: 320px;
            height: 520px;
        }
    }

    /* Tablet (max 768px) */
    @media (max-width: 768px) {
        /* Add your changes here */
        #rag-widget-root {
            bottom: 16px;
            right: 16px;
        }

        .irw-btn-float {
            width: 70px;
            height: 70px;
            padding: 12px;
        }

        .irw-chat-window {
            width: 92vw;
            height: 80vh;
            border-radius: 10px;
        }
.irw-chat-window.open {
    display: flex;
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: auto;
    width: 339px;
    /* margin-top: 209px; */
}
        .irw-float-bubble-text {
            font-size: 16px;
        }
    }

    /* Mobile (max 480px) */
    @media (max-width: 480px) {
        /* Add your changes here */
        .irw-btn-float {
            width: 60px;
            height: 60px;
            padding: 10px;
        }

        .irw-chat-window {
            width: 94vw;
            height: 85vh;
        }
.irw-chat-window.open {
    display: flex;
    opacity: 1;
    transform: translateY(0) scale(1);
    pointer-events: auto;
    width: 317px;
    /* margin-top: 209px; */
}
        .irw-message {
            font-size: 13px;
        }
    }

    /* Smallest Mobile (max 320px) */
    @media (max-width: 320px) {
        /* Add your changes here */
        .irw-btn-float {
            width: 52px;
            height: 52px;
        }

        .irw-chat-window {
            width: 96vw;
            height: 88vh;
        }

        .irw-message {
            font-size: 12px;
        }

        .irw-float-bubble-text {
            font-size: 14px;
        }
            .irw-chat-window.open {
        display: flex;
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: auto;
        width: 302px;
        /* height: 419px; */
        margin-right: -10px;
        /* margin-left: 74px; */
        /* margin-top: 209px; */
    }

    }
        `;

    const styleEl = document.createElement('style');
    styleEl.id = styleId;
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  // --- DOM Elements ---
  let rootEl, chatWindowEl, messagesEl, inputAreaEl, inputEl, sendBtnEl, micBtnEl, floatBtnEl;

  // --- Logic ---

  function init(config) {
    Object.assign(CONFIG, config);
    injectStyles();
    renderWidget();
    attachEventListeners();
    STATE.messages = [];
    STATE.currentStep = 'select_language';
  }

  function renderWidget() {
    const container = CONFIG.containerId ? document.getElementById(CONFIG.containerId) : document.body;

    rootEl = document.createElement('div');
    rootEl.id = 'rag-widget-root';
    rootEl.style.position = 'fixed';
    rootEl.style.bottom = '20px';
    rootEl.style.right = '20px';
    rootEl.style.zIndex = '9999';
    rootEl.style.display = 'flex';
    rootEl.style.flexDirection = 'column';
    rootEl.style.alignItems = 'flex-end';

    rootEl.innerHTML = `
            <div class="irw-chat-window" id="irw-chat-window">
                <div class="irw-header">
                    <div class="irw-header-title">
                        ${ICONS.bot}
                <span id="irw-header-text">${t('samadhan')}</span>
                    </div>
                    <button class="irw-btn-close" id="irw-btn-close">×</button>
                </div>
                <div class="irw-messages" id="irw-messages">
                    <!-- Messages go here -->
                </div>
                <div class="irw-input-area" id="irw-input-area" style="display: none;">
                    <input type="text" class="irw-input" id="irw-input" placeholder="Type your message...">
                    <button class="irw-btn-icon irw-btn-mic" id="irw-btn-mic">${ICONS.mic}</button>
                    <button class="irw-btn-icon irw-btn-send" id="irw-btn-send">${ICONS.send}</button>

                </div>
            </div>
            <div style="position: relative; display: inline-block;">
                <div class="irw-float-bubble" id="irw-float-bubble">
                    <p class="irw-float-bubble-text">${t('samadhan')}</p>
                    <div class="irw-float-bubble-arrow"></div>
                </div>
                <button class="irw-btn-float" id="irw-btn-float">
                    <img src="${chatbotIcon}" alt="Chatbot" style="width: 100%; height: 100%; object-fit: contain; filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));">
                </button>
            </div>
        `;

    container.appendChild(rootEl);

    chatWindowEl = rootEl.querySelector('#irw-chat-window');
    messagesEl = rootEl.querySelector('#irw-messages');
    inputAreaEl = rootEl.querySelector('#irw-input-area');
    inputEl = rootEl.querySelector('#irw-input');
    sendBtnEl = rootEl.querySelector('#irw-btn-send');
    micBtnEl = rootEl.querySelector('#irw-btn-mic');
    floatBtnEl = rootEl.querySelector('#irw-btn-float');




    renderStep();
  }

  function toggleChat() {
    STATE.isOpen = !STATE.isOpen;
    if (STATE.isOpen) {
      chatWindowEl.classList.add('open');
      floatBtnEl.style.display = 'none';
      rootEl.querySelector('#irw-float-bubble').style.display = 'none';

      const storedLang = getStoredLanguage();
      if (storedLang !== STATE.lang) {
        STATE.lang = storedLang;
        STATE.currentStep = 'select_service';
        STATE.messages = [];
        STATE.selectedService = '';
      }

      if (STATE.messages.length === 0) {
        renderStep();
      }
      scrollToBottom();
    } else {
      chatWindowEl.classList.remove('open');
      floatBtnEl.style.display = 'flex';
      rootEl.querySelector('#irw-float-bubble').style.display = 'block';
    }
  }

  function attachEventListeners() {
    floatBtnEl.addEventListener('click', toggleChat);
    rootEl.querySelector('#irw-btn-close').addEventListener('click', toggleChat);

    sendBtnEl.addEventListener('click', handleSend);
    inputEl.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') handleSend();
    });
    micBtnEl.addEventListener('click', toggleMic);

    window.addEventListener("languageChanged", (event) => {
      const newLang = event.detail;
      if (['en', 'hi', 'od'].includes(newLang) && newLang !== STATE.lang) {
        STATE.lang = newLang;
        updateHeaderTitle();
        if (STATE.isOpen && STATE.currentStep === 'select_language') {
          renderStep();
        } else if (STATE.isOpen && STATE.currentStep === 'select_service') {
          renderStep();
        }
      }
    });
  }

  function addMessage(content, type, options = []) {
    const msg = {
      id: Date.now(),
      type,
      content,
      options,
      timestamp: new Date()
    };
    STATE.messages.push(msg);
    renderMessage(msg);
    if (options.length > 0) {
      renderOptions(options);
    }
    scrollToBottom();
  }

  function renderMessage(msg) {
    const div = document.createElement('div');
    div.className = `irw-message ${msg.type}`;

    // Security: Escape HTML to prevent XSS
    const safeContent = msg.content
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

    let html = safeContent
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br/>');
    div.innerHTML = html;
    messagesEl.appendChild(div);
  }

  function renderOptions(options) {
    const div = document.createElement('div');
    div.className = 'irw-options';
    options.forEach(opt => {
      // const btn = document.createElement('button');
      // btn.className = 'irw-btn-option';
      // const label = t(`categories.${opt}`) !== `categories.${opt}` ? t(`categories.${opt}`) : opt;
      // btn.textContent = label;
      // btn.onclick = () => handleOptionClick(opt);
      // div.appendChild(btn);
      const btn = document.createElement('button');
      btn.className = 'irw-btn-option';
      btn.textContent = opt.label;
      btn.onclick = () => handleOptionClick(opt.key);   // FIXED
      div.appendChild(btn);
    });
    messagesEl.appendChild(div);
  }

  function scrollToBottom() {
    setTimeout(() => {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }, 50);
  }

  function updateHeaderTitle() {
    const headerTextEl = document.getElementById('irw-header-text');
    const bubbleTextEl = rootEl.querySelector('.irw-float-bubble-text');
    if (!headerTextEl) return;

    const headerT = (key) => LOCALES[STATE.lang][key] || LOCALES['en'][key];
    let title = t('samadhan');
    const { selectedService, currentStep } = STATE;

    if (
      selectedService === 'grievance_registration' ||
      currentStep === 'show_grievance_form' ||
      currentStep === 'collect_user_name' ||
      currentStep === 'collect_user_phone' ||
      currentStep === 'collect_grievant_name' ||
      currentStep === 'collect_grievant_phone' ||
      currentStep === 'verify_user_otp'
    ) {
      title = headerT('chat_title');
    } else if (selectedService === 'services_info' || currentStep === 'services_info') {
      title = headerT('service_know_citizen');
    } else if (selectedService === 'check_status' || currentStep === 'check_grievance_status') {
      title = headerT('service_check_status');
    } else if (selectedService === 'feedback' || currentStep === 'collect_feedback_name' || currentStep === 'collect_feedback_phone'
      || currentStep === 'collect_feedback_message') {
      title = headerT('service_feedback');
    }

    headerTextEl.textContent = title;
    if (bubbleTextEl) {
      bubbleTextEl.textContent = t('samadhan');
    }
  }

  function renderStep() {
    const stepT = (key, vars = {}) => {
      let str = LOCALES[STATE.lang][key] || LOCALES['en'][key] || key;
      Object.keys(vars).forEach(k => {
        str = str.replace(`{${k}}`, vars[k]);
      });
      return str;
    };

    messagesEl.innerHTML = '';

    const storedLang = getStoredLanguage();
    if (STATE.currentStep === 'select_language' && storedLang !== 'en' && STATE.messages.length === 0 && !STATE.preventRedirect) {
      STATE.lang = storedLang;
      STATE.currentStep = 'select_service';
    } else {
      STATE.preventRedirect = false;
    }

    if (STATE.currentStep === 'select_language') {
      inputAreaEl.style.display = 'none';
      messagesEl.innerHTML = '';

      const langContainer = document.createElement('div');
      langContainer.innerHTML = `<h3 style="margin-bottom:12px; font-weight:600; color:#374151;">${t('select_language')}</h3>`;

      const langs = [
        { code: 'od', name: 'ଓଡ଼ିଆ' },
        { code: 'hi', name: 'हिंदी' },
        { code: 'en', name: 'English' },
      ];

      langs.forEach(l => {
        const btn = document.createElement('button');
        btn.className = 'irw-lang-btn';
        btn.textContent = l.name;
        btn.onclick = () => {
          STATE.lang = l.code;
          STATE.currentStep = 'select_service';
          renderStep();
        };
        langContainer.appendChild(btn);
      });
      messagesEl.appendChild(langContainer);
      return;
    }

    updateHeaderTitle();

    if (STATE.currentStep === 'select_service') {
      inputAreaEl.style.display = 'none';
      messagesEl.innerHTML = '';

      const backBtn = document.createElement('button');
      backBtn.className = 'irw-back-btn';
      backBtn.innerHTML = ICONS.arrowLeft;
      backBtn.onclick = () => {
        STATE.currentStep = 'select_language';
        STATE.preventRedirect = true;
        renderStep();
      };
      messagesEl.appendChild(backBtn);

      const container = document.createElement('div');
      container.className = 'irw-service-container';

      const title = document.createElement('div');
      title.className = 'irw-service-title';
      title.textContent = stepT('select_service');
      container.appendChild(title);

      const services = [
        { key: 'services_info', label: stepT('service_know_citizen'), grad: 'linear-gradient(135deg, #0ea5e9 0%, #10b981 50%, #f59e0b 100%)', hover: 'linear-gradient(135deg, #0284c7 0%, #0ea568 50%, #d97706 100%)' },
        { key: 'grievance_registration', label: stepT('service_grievance_registration'), grad: 'linear-gradient(135deg, #9333ea 0%, #f97316 100%)', hover: 'linear-gradient(135deg, #7e22ce 0%, #ea580c 100%)' },
        { key: 'check_status', label: stepT('service_check_status'), grad: 'linear-gradient(135deg, #8b5cf6 0%, #fb923c 100%)', hover: 'linear-gradient(135deg, #7c3aed 0%, #f97316 100%)' },
        // { key: 'feedback', label: stepT('service_feedback'), grad: 'linear-gradient(135deg, #a855f7 0%, #14b8a6 100%)', hover: 'linear-gradient(135deg, #9333ea 0%, #0d9488 100%)' }
      ];

      services.forEach(s => {
        const btn = document.createElement('button');
        btn.className = 'irw-service-btn';
        btn.style.background = s.grad;
        btn.textContent = s.label;
        btn.onclick = () => handleServiceSelect(s.key);

        btn.onmouseenter = () => { btn.style.background = s.hover; };
        btn.onmouseleave = () => { btn.style.background = s.grad; };

        container.appendChild(btn);
      });

      messagesEl.appendChild(container);
      return;
    }

    inputAreaEl.style.display = 'flex';
    inputEl.placeholder = stepT('placeholder_message');

    if (STATE.currentStep === 'select_category') {
      inputEl.disabled = true;
      sendBtnEl.disabled = true;
      micBtnEl.disabled = true;
      inputEl.placeholder = "Please select an option above...";
      inputAreaEl.style.opacity = '0.6';
    } else {
      inputEl.disabled = false;
      sendBtnEl.disabled = false;
      micBtnEl.disabled = false;
      inputAreaEl.style.opacity = '1';
    }
    messagesEl.innerHTML = '';

    if (STATE.selectedService) {
      const backBtn = document.createElement('button');
      backBtn.className = 'irw-back-btn';
      backBtn.innerHTML = ICONS.arrowLeft;
      backBtn.onclick = () => {
        STATE.currentStep = 'select_service';
        STATE.messages = [];
        STATE.selectedService = '';
        renderStep();
      };
      messagesEl.appendChild(backBtn);
    }

    STATE.messages.forEach(msg => {
      renderMessage(msg);
      if (msg.options) renderOptions(msg.options);
    });

    if (STATE.currentStep === 'show_grievance_form') {
      renderGrievanceForm();
      inputAreaEl.style.display = 'none';
    } else if (STATE.currentStep === 'collect_feedback_message' || STATE.showFeedbackForm) {
      renderFeedbackForm();
      inputAreaEl.style.display = 'none';
    }

    scrollToBottom();
  }

  function handleServiceSelect(service) {
    STATE.selectedService = service;
    STATE.messages = [];

    switch (service) {
      case 'grievance_registration':
        STATE.currentStep = 'greeting';
        addMessage(t('greeting'), 'bot');
        setTimeout(() => {
          // Create entries: [["self","खुद"], ["ashakarmi","आशा कर्मी"], ...]
          const categoryEntries = Object.entries(LOCALES[STATE.lang].categories);

          // Prepare options as { key, label }
          const categoryOptions = categoryEntries.map(([key, label]) => ({
            key,
            label
          }));

          // console.log(categoryEntries)
          // console.log("ctoptions", categoryOptions)
          // addMessage(t('who_are_you'), 'bot', ['Self', 'Asha Karmi', 'Anganbadi Karmi', 'CSC', 'Ration_Card_Dealer', 'Other']);
          addMessage(t('who_are_you'), 'bot', categoryOptions)
          STATE.currentStep = 'select_category';
          renderStep();
        }, 500);
        break;
      case 'services_info':
        STATE.currentStep = 'services_info';
        addMessage(t('service_info_prompt'), 'bot');
        break;
      case 'check_status':
        STATE.currentStep = 'check_grievance_status';
        addMessage(t('check_grievance_status'), 'bot');
        addMessage(t('placeholder_grievance_id'), 'bot');
        break;
      case 'feedback':
        STATE.currentStep = 'collect_feedback_name';
        STATE.feedbackDetails = { name: '', mobileNumber: '', feedback: '' };
        addMessage(t('feedback_prompt'), 'bot');
        setTimeout(() => {
          addMessage(t('enter_name'), 'bot');
        }, 300);
        break;
    }
    renderStep();
  }

  function handleOptionClick(optKey) {
    const lastMsg = messagesEl.lastElementChild;
    if (lastMsg && lastMsg.querySelector('.irw-options')) {
      lastMsg.querySelector('.irw-options').remove();
    }

    // const categoryLabel = LOCALES[STATE.lang]?.categories?.[opt] || LOCALES['en']?.categories?.[opt] || opt;
    // addMessage(categoryLabel, 'user');

    if (STATE.currentStep === 'select_category') {
      // console.log("opt", optKey)
      // STATE.userDetails.category = opt.toLowerCase().replace(/\s+/g, "");
      // // Prepare options as { key, label }
      // const categoryOptions = categoryEntries.map(([key, label]) => ({
      //   key,
      //   label
      // }));
      // STATE.userDetails.category = opt.toLowerCase().replace(/\s+/g, "");

      const label = LOCALES[STATE.lang].categories[optKey];

      addMessage(label, "user");

      // save correct key
      STATE.userDetails.category = optKey;


      if (optKey === 'Self') {
        setTimeout(() => {
          addMessage(t('enter_name'), 'bot');
          STATE.currentStep = 'collect_user_name';
          renderStep();
        }, 500);
      } else {
        // const categoryForMsg = LOCALES[STATE.lang]?.categories?.[opt.toLowerCase().replace(/\s+/g, "")] || LOCALES['en']?.categories?.[opt.toLowerCase().replace(/\s+/g, "")] || opt.toLowerCase().replace(/\s+/g, "");
        // setTimeout(() => {
        //   addMessage(t('enter_grievant_name', { category: categoryForMsg }), 'bot');
        //   STATE.currentStep = 'collect_user_name';
        //   renderStep();

        setTimeout(() => {
          addMessage(
            t("enter_grievant_name", { category: label }),
            "bot"
          );
          STATE.currentStep = "collect_user_name";
          renderStep();
        }, 500);
      }
    }
  }

  async function handleSend() {
    const text = inputEl.value.trim();
    if (!text) return;

    inputEl.value = '';
    addMessage(text, 'user');

    switch (STATE.currentStep) {
      case 'collect_user_name':
        STATE.userDetails.userName = text;
        setTimeout(() => {
          addMessage(t('enter_phone'), 'bot');
          STATE.currentStep = 'collect_user_phone';
        }, 500);
        break;

      case 'collect_user_phone':
        if (!/^\d{10}$/.test(text)) {
          addMessage(t('error_phone'), 'bot');
          return;
        }
        STATE.userDetails.userPhone = text;
        addMessage(t('otp_sent'), 'bot');
        await apiRegister(text);
        setTimeout(() => {
          addMessage(t('enter_otp'), 'bot');
          STATE.currentStep = 'verify_user_otp';
        }, 500);
        break;

      case 'verify_user_otp':
        const verified = await apiLogin(STATE.userDetails.userPhone, text);
        if (verified) {
          addMessage(t('otp_verified'), 'bot');
          if (STATE.userDetails.category === 'self') {
            STATE.currentStep = 'show_grievance_form';
            renderStep();
          } else {
            addMessage(t('enter_concerned_name'), 'bot');
            STATE.currentStep = 'collect_grievant_name';
          }
        } else {
          addMessage(t('error_otp'), 'bot');
        }
        break;

      case 'collect_grievant_name':
        STATE.userDetails.grievantName = text;
        addMessage(t('enter_grievant_phone'), 'bot');
        STATE.currentStep = 'collect_grievant_phone';
        break;

      case 'collect_grievant_phone':
        if (text.toLowerCase() === 'skip') {
          STATE.userDetails.grievantPhone = '';
        } else {
          STATE.userDetails.grievantPhone = text;
        }
        STATE.currentStep = 'show_grievance_form';
        renderStep();
        break;

      case 'services_info':
        showLoader();
        try {
          const ans = await apiServiceInfo(text);
          hideLoader();
          addMessage(ans, 'bot');
        } catch (e) {
          hideLoader();
          addMessage(t('service_info_error'), 'bot');
        }
        break;

      case 'check_grievance_status':
        showLoader();
        try {
          const status = await apiCheckStatus(text);
          hideLoader();
          addMessage(status, 'bot');
        } catch (e) {
          hideLoader();
          addMessage(t('error_fetching_status'), 'bot');
        }
        break;

      case 'collect_feedback_name':
        STATE.feedbackDetails.name = text;
        addMessage(t('enter_phone'), 'bot');
        STATE.currentStep = 'collect_feedback_phone';
        break;

      // case 'collect_feedback_phone':
      //   STATE.feedbackDetails.mobileNumber = text;
      //    STATE.showFeedbackForm = true;
      //   STATE.currentStep = 'collect_feedback_message';
      //   renderStep();
      //   break;
      case 'collect_feedback_phone': {

        // Remove everything except digits
        const clean = text.replace(/\D/g, "").trim();

        // Validate length = 10
        if (clean.length !== 10) {
          addMessage("📱 Please enter a valid *10-digit* mobile number.", "bot");
          return; // Stop and ask again
        }

        STATE.feedbackDetails.mobileNumber = clean;

        STATE.showFeedbackForm = true;
        STATE.currentStep = 'collect_feedback_message';
        renderStep();
        break;
      }


    }
  }

  function renderGrievanceForm() {
    const formDiv = document.createElement('div');
    formDiv.className = 'irw-form-container';

    formDiv.innerHTML = `
            <label class="irw-label">${t('describe_grievance')}</label>
            <div class="irw-textarea-container">
                <textarea class="irw-textarea" id="irw-grievance-desc" placeholder="${t('placeholder_grievance')}"></textarea>
                <button type="button" class="irw-mic-textarea-btn" id="irw-grievance-mic">${ICONS.mic}</button>

            </div>
            <div id="irw-error" style="color: red; font-size: 12px; margin-top: 3px;"></div>

            
            <label class="irw-label">${t('upload_documents')}</label>
            <input type="file" multiple class="irw-file-input" id="irw-grievance-files">
            
            <div class="irw-btn-group">
                <button class="irw-btn-primary" id="irw-form-submit">${t('submit')}</button>
                <button class="irw-btn-secondary" id="irw-form-cancel">${t('cancel')}</button>
            </div>
        `;

    messagesEl.appendChild(formDiv);

    const textarea = formDiv.querySelector('#irw-grievance-desc');
    const micBtn = formDiv.querySelector('#irw-grievance-mic');


    const desc = formDiv.querySelector('#irw-grievance-desc');   // textarea
    const irwError = formDiv.querySelector('#irw-error');            // error div

    desc.addEventListener("input", () => {
      const value = textarea.value.trim();

      if (value.length > 0 && value.length <= 10) {
        irwError.textContent = "Please write more than 10 characters";
      } else {
        irwError.textContent = "";
      }
    });


    micBtn.onclick = () => handleTextareaTranscription(textarea, micBtn);

    formDiv.querySelector('#irw-form-cancel').onclick = () => {
      STATE.currentStep = 'select_service';
      STATE.selectedService = '';
      renderStep();
    };

    formDiv.querySelector('#irw-form-submit').onclick = async () => {
      const desc = textarea.value;
      const files = formDiv.querySelector('#irw-grievance-files').files;

      if (!desc) {
        alert(t('error_description'));
        return;
      }

      const btn = formDiv.querySelector('#irw-form-submit');
      btn.textContent = t('submitting');
      btn.disabled = true;

      addMessage(desc, 'user')
      formDiv.style.display = 'none';
      showLoader();

      try {
        const res = await apiSubmitGrievance(desc, files);
        if (res.success) {
          hideLoader();
          addMessage(t('grievance_registered', { id: res.data?.grievanceId || 'N/A' }), 'bot');
          STATE.currentStep = 'complete';
          inputAreaEl.style.display = 'none';
          btn.textContent = t('submit');
        } else {
          hideLoader();
          alert(t('error_submitting'));
          btn.textContent = t('submit');
          btn.disabled = false;
        }
      } catch (e) {
        hideLoader();
        console.error(e);
        alert(t('error_submitting'));
        btn.textContent = t('submit');
        btn.disabled = false;
      }
    };
  }

  function renderFeedbackForm() {
    const formDiv = document.createElement('div');
    formDiv.className = 'irw-form-container';

    formDiv.innerHTML = `
            <label class="irw-label">${t('feedback_describe_label')}</label>
            <div class="irw-textarea-container">
                <textarea class="irw-textarea" id="irw-feedback-desc" placeholder="${t('feedback_placeholder')}"></textarea>
                <button type="button" class="irw-mic-textarea-btn" id="irw-feedback-mic">${ICONS.mic}</button>
            </div>
            
            <div class="irw-btn-group">
                <button class="irw-btn-primary" id="irw-feedback-submit">${t('submit')}</button>
                <button class="irw-btn-secondary" id="irw-feedback-cancel">${t('cancel')}</button>
            </div>
        `;

    messagesEl.appendChild(formDiv);

    const textarea = formDiv.querySelector('#irw-feedback-desc');
    const micBtn = formDiv.querySelector('#irw-feedback-mic');

    micBtn.onclick = () => handleTextareaTranscription(textarea, micBtn);

    formDiv.querySelector('#irw-feedback-cancel').onclick = () => {
      STATE.currentStep = 'select_service';
      STATE.selectedService = '';
      STATE.feedbackDetails = {};
      renderStep();
    };

    formDiv.querySelector('#irw-feedback-submit').onclick = async () => {
      const desc = textarea.value;
      if (!desc) {
        alert('Please provide your feedback.');
        return;
      }

      const btn = formDiv.querySelector('#irw-feedback-submit');
      btn.textContent = t('submitting');
      btn.disabled = true;

      try {
        const res = await apiFeedback({
          name: STATE.feedbackDetails.name,
          mobileNumber: STATE.feedbackDetails.mobileNumber,
          feedback: desc
        });

        if (res.success) {
          addMessage(t('feedback_thanks'), 'bot');
          STATE.currentStep = 'complete';
          inputAreaEl.style.display = 'none';
          btn.textContent = t('submit');
          let feedbackform = document.querySelector('.irw-form-container')
          feedbackform.style.display = 'none';
        }
      } catch (e) {
        console.error(e);
        alert(t('feedback_error'));
        btn.textContent = t('submit');
        btn.disabled = false;
      }
    };
  }

  function showLoader() {
    const div = document.createElement('div');
    div.className = 'irw-loader';
    div.id = 'irw-loader';
    div.innerHTML = `<div class="irw-dot"></div><div class="irw-dot"></div><div class="irw-dot"></div>`;
    messagesEl.appendChild(div);
    scrollToBottom();
  }

  function hideLoader() {
    const loader = messagesEl.querySelector('#irw-loader');
    if (loader) loader.remove();
  }

  // --- API Calls ---

  async function apiRegister(mobile) {
    try {
      const res = await fetch(`${CONFIG.backendBaseUrl}/auth/users/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'register', mobile, name: STATE.userDetails.userName, language: STATE.lang })
      });
      return await res.json();
    } catch (e) {
      console.error(e);
      return { success: false };
    }
  }
const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";

  const d = new Date(dateString);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12
  hours = String(hours).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
};

const capitalizeFirst = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
  async function apiLogin(mobile, otp) {
    try {
      const res = await fetch(`${CONFIG.backendBaseUrl}/auth/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'login', mobile, otp })
      });
      const data = await res.json();
      if (data.success && data.data?.token) {
        STATE.token = data.data.token;
        return true;
      }
      return false;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  // --- RAG Helpers ---
  let cachedRows = null;

  async function parseCsv() {
    if (cachedRows) return cachedRows;
    try {
      const res = await fetch('Schemes_Full.csv');
      const raw = await res.text();
      const lines = raw.split(/\r?\n/).filter(Boolean);
      if (lines.length < 2) return [];

      const headers = lines[0].split(',').map(h => h.trim());
      const rows = [];

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(',').map(c => c.trim());
        const row = {};
        headers.forEach((h, idx) => {
          row[h] = cols[idx] || '';
        });
        rows.push(row);
      }
      cachedRows = rows;
      return rows;
    } catch (e) {
      console.error('Failed to load CSV:', e);
      return [];
    }
  }

  async function retrieveRelevantRows(query, limit = 6) {
    const rows = await parseCsv();
    const terms = query.toLowerCase().split(/\s+/).filter(Boolean);

    const scored = rows.map(row => {
      const text = Object.values(row).join(' ').toLowerCase();
      const score = terms.reduce((acc, term) => (text.includes(term) ? acc + 1 : acc), 0);
      return { row, score };
    })
      .filter(item => item.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, limit);

    if (scored.length === 0) {
      return rows.slice(0, limit);
    }
    return scored.map(item => item.row);
  }

  function formatRows(rows) {
    return rows.map((row, idx) => {
      const parts = Object.entries(row)
        .map(([key, value]) => `${key}: ${value}`)
        .join(' | ');
      return `${idx + 1}. ${parts}`;
    }).join('\n');
  }

  async function apiServiceInfo(query) {
    try {


      // Logic handled by backend (gemini.js)
      // CSV parsing and RAG prompt construction removed from here to separate concerns.
      // Functions parseCsv, retrieveRelevantRows etc. are kept below for reference.

      const response = await fetch(`${CONFIG.backendBaseUrl}/widget/service-info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query: query,
          language: STATE.lang
        })
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.error.message);
        throw new Error(data.error?.message || 'Gemini API Error');
      }

      const text = data.data.response || 'Sorry, I could not generate a response.';

      STATE.infoMemory.push({ q: query, a: text });
      return text;

    } catch (e) {
      console.error('Service info error:', e);
      return t('service_info_error');
    }
  }

  async function apiSubmitGrievance(description, files) {
    // console.log(files)
    const formData = new FormData();
    formData.append('description', description);
    formData.append('mobile', STATE.userDetails.userPhone);
    formData.append('userCategory', STATE.userDetails.category);
    formData.append('submissionChannel', 'bot');


    // ---------- GET DEVICE LOCATION ----------
    const deviceLocation = await getDeviceLocation();
    formData.append("location", JSON.stringify(deviceLocation));


    // formData.append('location', JSON.stringify({ latitude: 20.2961, longitude: 85.8245 }));

    if (STATE.userDetails.grievantName) {
      formData.append('submittedFor', JSON.stringify({
        name: STATE.userDetails.grievantName,
        mobile: STATE.userDetails.grievantPhone
      }));
    }

    for (let i = 0; i < files.length; i++) {
      formData.append('images', files[i]);
    }

    const res = await fetch(`${CONFIG.backendBaseUrl}/grievances`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${STATE.token}`
      },
      body: formData
    });
    return await res.json();
  }



  // ----------------Location HELPER FUNCTION ----------------
  async function getDeviceLocation() {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        return resolve({
          latitude: 20.2961,
          longitude: 85.8245,
          accurate: false,
          reason: "Geolocation not supported",
        });
      }

      // First attempt – high accuracy
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          resolve({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
            accurate: true,
          });
        },
        (err) => {
          console.warn("High accuracy failed:", err);

          // Second attempt – low accuracy (faster)
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              resolve({
                latitude: pos.coords.latitude,
                longitude: pos.coords.longitude,
                accurate: false, // less accurate
                reason: "Low accuracy fallback",
              });
            },
            (err2) => {
              console.warn("Low accuracy failed:", err2);
            },
            { enableHighAccuracy: false, timeout: 20000 }
          );
        },
        { enableHighAccuracy: true, timeout: 20000 }
      );
    });
  }


  async function apiFeedback(feedbackData) {
    try {
      const res = await fetch(`${CONFIG.feedbackUrl}/generalfeedback/add-general-feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: feedbackData.name,
          mobileNumber: feedbackData.mobileNumber,
          feedback: feedbackData.feedback,

        })
      });
      return await res.json();
    } catch (error) {
      console.log(error)
    }
  }

  async function apiCheckStatus(id) {

    try {
      const data = await fetch(`${CONFIG.backendBaseUrl}/grievances/public/${id}`)
      const res = await data.json();

      // return `Status for ${id}: In Progress. Expected resolution: 7 days.`;
      //       return `
      // <div style="
      //   background:#f7f9fc;
      //   padding:15px;
      //   border-radius:12px;
      //   border:1px solid #dce3eb;
      //   font-family:Arial;
      //   line-height:1.6;
      // ">
      //   <h3 style="margin:0 0 10px 0;">📌 Grievance Status</h3>

      //   <p><b>🆔 ID:</b> ${res.data.grievanceId}</p>
      //   <p><b>📝 Description:</b> ${res.data.description}</p>
      //   <p><b>🏷️ Category:</b> ${res.data.category}</p>
      //   <p><b>🏛️ Department:</b> ${res.data.department}</p>
      //   <p><b>📊 Current Status:</b> ${res.data.status}</p>
      //   <p><b>⏳ Estimated Resolution:</b> ${new Date(res.data.estimatedResolutionDate).toLocaleString()}</p>
      //   <p><b>🕒 Submitted At:</b> ${new Date(res.data.createdAt).toLocaleString()}</p>
      //       <h4 style="
      //   margin: 0 0 6px 0;
      //   font-size: 15px;
      //   font-weight: 600;
      //   color: #0d47a1;
      // ">📜 Status History:</h4>

      // <div>
      //   ${res.data.statusHistory
      //           .map(
      //             (h) => `
      //       <div style="
      //         padding: 4px 6px;
      //         background: #f5f7fa;
      //         border-radius: 6px;
      //         margin-bottom: 4px;
      //         font-size: 13px;
      //         line-height: 1.2;
      //       ">
      //         <b>${h.newStatus}</b> — ${new Date(h.timestamp).toLocaleString()}
      //         <br>
      //         <span style="color:#555; font-style:italic;">${h.remarks}</span>
      //       </div>
      //       `
      //           )
      //           .join("")}
      // </div>


      // </div>
      // `;



 return `

        📌 GRIEVANCE STATUS

🆔  Grievance ID: ${res.data.grievanceId}

📝  Description: ${res.data.description}

🏷️  Category: ${capitalizeFirst(res.data.category)}

🏛️  Department: ${res.data.department}

📊  Current Status: ${capitalizeFirst(res.data.status)}

⏳  Estimated Resolution: ${formatDateTime(res.data.estimatedResolutionDate)}

🕒  Submitted At: ${formatDateTime(res.data.createdAt)}

        📜 STATUS HISTORY

${res.data.statusHistory
  .map(
    (h) =>
      `🔹 ${capitalizeFirst(h.newStatus)}
   🗓️ ${formatDateTime(h.timestamp)}
   💬 ${capitalizeFirst(h.remarks || "No Remarks")}`
  )
  .join("\n\n")}


`;
    } catch (error) {
      console.log(error);
      return "❌ Please Enter Valid Grievance ID.";
    }
  }



  //   async function apiCheckStatus(id) {
  //   try {
  //     const data = await fetch(`${ CONFIG.backendBaseUrl } /grievances/public / ${ id } `);
  //     const res = await data.json();
  //     const g = res.data;
  //     console.log(g)

  //    return `
      // <div style="
      //   background: #ffffff;
      //   padding: 10px;
      //   border-radius: 16px;
      //   border: 1px solid #e0e6ed;
      //   font-family: 'Inter', 'Segoe UI', sans-serif; /* Modern Font Stack */
      //   line-height: 1;
      //   color: #333333;
      //   box-shadow: 0 10px 30px rgba(0,0,0,0.07); /* More prominent, soft shadow */
      //   height: 200px;
      // ">

      //   <h3 style="
      //     font-size: 22px;
      //     font-weight: 700;
      //     color: #00796b; /* Teal Accent Color */
      //     border-bottom: 2px solid #e0f2f1;
      //     display: flex;
      //     align-items: center;
      //     gap: 2px;
      //   ">⭐ Grievance Status Tracker</h3>

      //   <div style="
      //     background: linear-gradient(135deg, #f7f9fa, #f0f4f7); /* Subtle gradient background */
      //     padding: 16px;
      //     border-radius: 12px;

      //     border-left: 5px solid #00796b;
      //   ">
      //     <p style="">
      //         <span style="font-weight: 600; color:#5a5a5a;">🆔 Grievance ID:</span> 
      //         <span style="font-family: monospace; color: #00796b;">${g.grievanceId}</span>
      //     </p>
      //     <p style="">
      //         <span style="font-weight: 600; color:#5a5a5a;">📝 Description:</span> ${g.description}
      //     </p>
      //     <p style="">
      //         <span style="font-weight: 600; color:#5a5a5a;">🏷️ Category:</span> ${g.category}
      //     </p>
      //     <p style="">
      //         <span style="font-weight: 600; color:#5a5a5a;">🏛️ Department:</span> ${g.department}
      //     </p>

      //     <div style="margin-top: 2px; padding-top: 10px; border-top: 1px dashed #cfd8dc;">
      //         <p style="">
      //             <span style="font-weight: 700; color:#00796b; font-size: 15px;">📊 Current Status:</span> 
      //             <span style="
      //                 /* Dynamic Status Styling */
      //                 background: ${g.status === 'resolved' ? '#e8f5e9' : g.status === 'pending' ? '#fffde7' : '#e3f2fd'};
      //                 color: ${g.status === 'resolved' ? '#388e3c' : g.status === 'pending' ? '#fbc02d' : '#1976d2'};
      //                 padding: 5px 12px;
      //                 border-radius: 20px;
      //                 font-size: 14px;
      //                 font-weight: 700;
      //                 text-transform: uppercase;
      //                 letter-spacing: 0.5px;
      //                 box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      //             ">
      //                 ${g.status}
      //             </span>
      //         </p>
      //     </div>

      //     <p style="margin:2px 0 0 0;">
      //         <span style="font-weight: 600; color:#5a5a5a;">⏳ Estimated Resolution:</span> 
      //         <span style="color: #d32f2f; font-weight: 500;">${new Date(g.estimatedResolutionDate).toLocaleString()}</span>
      //     </p>
      //     <p style="margin:2px 0 0 0;">
      //         <span style="font-weight: 600; color:#5a5a5a;">🕒 Submitted At:</span> ${new Date(g.createdAt).toLocaleString()}
      //     </p>
      //   </div>

      //   <h4 style="
      //     /* History Header */
      //     margin-top: 2px;
      //     margin-bottom: 2px;
      //     font-size: 18px;
      //     font-weight: 600;
      //     color:#00796b;
      //   ">📜 Status History - Timeline</h4>

      //   <div style="
      //     /* Timeline Container */
      //     border-left: 2px dashed #b0bec5;
      //     padding-left: 20px;
      //     position: relative;
      //   ">
      //     ${g.statusHistory
      //       .map(
      //         (h) => `
      //         <div style="margin-bottom: 2px; position: relative;">

      //           <div style="
      //             position: absolute;
      //             left: -31px; /* Align with the dashed line */
      //             top: 0;
      //             width: 10px;
      //             height: 10px;
      //             background-color: #00796b;
      //             border-radius: 50%;
      //             border: 3px solid #ffffff;
      //             box-shadow: 0 0 0 1px #00796b;
      //           "></div>

      //           <p style="margin: 0;">
      //             <span style="
      //               font-weight: 700;
      //               color: #00796b;
      //               font-size: 15px;
      //             ">${h.newStatus}</span>
      //             <span style="font-size: 13px; color: #78909c;">(${new Date(h.timestamp).toLocaleString()})</span>
      //           </p>
      //           <p style="
      //             margin: 2px 0 0 0;
      //             font-size: 14px;
      //             color: #555;
      //             font-style: italic;
      //             background: #fcfcfc;
      //             padding: 8px;
      //             border-radius: 6px;
      //             border: 1px solid #eee;
      //           ">${h.remarks}</p>
      //         </div>`
      //       )
      //       .join("")}
      //   </div>

      // </div>
      // `;

      //   } catch (error) {
      //     console.log(error);
      //     return "❌ Unable to fetch status at the moment.";
      //   }
      // }




      async function handleTextareaTranscription(textarea, micBtn) {
        const isRecording = micBtn.classList.contains('recording');

        if (isRecording) {
          micBtn.classList.remove('recording');
          micBtn.innerHTML = ICONS.mic;
          return;
        }



        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          const mediaRecorder = new MediaRecorder(stream);
          const audioChunks = [];

          mediaRecorder.ondataavailable = (e) => {
            audioChunks.push(e.data);
          };

          mediaRecorder.onstop = async () => {
            micBtn.classList.remove('recording');
            micBtn.innerHTML = ICONS.mic;

            const audioBlob = new Blob(audioChunks, { type: 'audio/webm' });
            const formData = new FormData();
            formData.append('audio', audioBlob, 'audio.webm');
            const langCode = STATE.lang === 'hi' ? 'hi-IN' : STATE.lang === 'od' ? 'od-IN' : 'en-IN';
            formData.append('language_code', JSON.stringify(langCode));

            try {
              const response = await fetch(`${CONFIG.backendBaseUrl}/transcribe`, {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${STATE.token}`,
                },
                body: formData,
              });

              if (!response.ok) throw new Error('Transcription failed');
              const data = await response.json();

              const transcript = data.transcript || data.data?.transcript;
              if (transcript) {
                textarea.value += (textarea.value ? ' ' : '') + transcript;
              }
            } catch (error) {
              console.error('Transcription error:', error);
              alert('Failed to transcribe audio');
            } finally {
              stream.getTracks().forEach((track) => track.stop());
            }
          };

          mediaRecorder.start();
          micBtn.classList.add('recording');
          micBtn.innerHTML = '<span class="irw-mic-stop-icon"></span>';

          setTimeout(() => {
            if (mediaRecorder.state !== 'inactive') {
              mediaRecorder.stop();
            }
          }, 10000);
        } catch (error) {
          console.error('Mic error:', error);
          alert('Microphone not available.');
          micBtn.classList.remove('recording');
          micBtn.innerHTML = ICONS.mic;
        }
      }

      async function toggleMic() {
        if (STATE.isListening) {
          stopListening();
        } else {
          startListening();
        }
      }

      async function startListening() {
        if (!navigator.mediaDevices) {
          alert('Microphone not supported');
          return;
        }
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          STATE.mediaRecorder = new MediaRecorder(stream);
          STATE.audioChunks = [];

          STATE.mediaRecorder.ondataavailable = e => STATE.audioChunks.push(e.data);
          STATE.mediaRecorder.onstop = async () => {
            const blob = new Blob(STATE.audioChunks, { type: 'audio/webm' });
            const formData = new FormData();
            formData.append('audio', blob, 'audio.webm');
            formData.append('language_code', JSON.stringify(STATE.lang === 'hi' ? 'hi-IN' : STATE.lang === 'od' ? 'od-IN' : 'en-IN'));

            // if (STATE.token) {
            //   try {
            //     const res = await fetch(`${CONFIG.backendBaseUrl}/transcribe`, {
            //       method: 'POST',
            //       headers: { 'Authorization': `Bearer ${STATE.token}` },
            //       body: formData
            //     });
            //     const data = await res.json();
            //     const text = data.transcript || data.data?.transcript;
            //     if (text) {
            //       inputEl.value += (inputEl.value ? ' ' : '') + text;
            //     }
            //   } catch (e) {
            //     console.error(e);
            //   }
            // } else {
            //   alert(t('error_auth'));
            // }



            try {
              const res = await fetch(`${CONFIG.backendBaseUrl}/transcribe`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${STATE.token}` },
                body: formData
              });
              const data = await res.json();
              const text = data.transcript || data.data?.transcript;
              if (text) {
                inputEl.value += (inputEl.value ? ' ' : '') + text;
              }
            } catch (e) {
              console.error(e);
            }
            micBtnEl.classList.remove('listening');
            micBtnEl.innerHTML = ICONS.mic;
            STATE.isListening = false;
            stream.getTracks().forEach(track => track.stop());
          };

          STATE.mediaRecorder.start();
          STATE.isListening = true;
          micBtnEl.classList.add('listening');
          micBtnEl.innerHTML = '<span class="irw-mic-stop-icon"></span>';

        } catch (e) {
          console.error(e);
          alert('Microphone access denied');
        }
      }



      function stopListening() {
        if (STATE.mediaRecorder && STATE.isListening) {
          STATE.mediaRecorder.stop();
        }
      }

      // --- Public API ---
      window.RAG_WIDGET = {
        init
      };

    }) (window);
